<template>
    <div class="fixed bottom-0 z-1000 w-full md:hidden" v-if="hasContent">
        <component :is="barComponent" />

        <!-- add some space at the bottom of the document so we don't overlap stuff -->
        <MountingPortal mountTo="body" append>
            <div class="h-20 md:hidden" />
        </MountingPortal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ClubBar from './ClubBar'
import CoachBar from './CoachBar'
import { MountingPortal } from 'portal-vue'

export default {
    components: { MountingPortal },

    computed: {
        ...mapGetters('athleteProfile', [
            'isApplicableClubStaff',
            'isApplicableCollegeCoach',
        ]),

        barComponent() {
            return (
                this.isApplicableClubStaff ? ClubBar :
                this.isApplicableCollegeCoach ? CoachBar :
                undefined
            )
        },

        hasContent() {
            return !!this.barComponent
        },
    }
}
</script>